import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { GlobalVariables } from 'global-variables';
import { Observable } from 'rxjs';


@Injectable({
  providedIn: 'root'
})
export class CollectionService {

  private url = GlobalVariables.appURL;
  private headers: HttpHeaders = new HttpHeaders();

  constructor(private _httpClient: HttpClient) {
    this.headers.append('Content-Type', 'multipart/form-data');
  }

  list(): Observable<any> {
    return this._httpClient.get(this.url + 'collection');
  }

  detail(id: string): Observable<any> {
    return this._httpClient.get(this.url + 'collection/' + id);
  }

  create(data: FormData): Observable<any> {
    return this._httpClient.post(this.url + 'collection', data, { headers: this.headers });
  }

  update(id: string, data: FormData): Observable<any> {
    return this._httpClient.patch(this.url + 'collection/' + id, data, { headers: this.headers });
  }

  delete(id: string): Observable<any> {
    return this._httpClient.delete(this.url + 'collection/' + id);
  }

  items(id: string): Observable<any> {
    return this._httpClient.get(this.url + 'collection/' + id + '/items');
  }

  saveItems(id: string, data: {productId: string, variantIds: string[]}[]): Observable<any> {
    return this._httpClient.patch(this.url + 'collection/' + id + '/items', data);
  }
}
